import { UrlUtils } from "../url";

const redirectQueryString = UrlUtils.getQueryString("redirectWecoma");
UrlUtils.clearUrlParams(["redirectWecoma"]);

export const wecomaRedirectActive = redirectQueryString === "" || !!redirectQueryString;
